// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4942c123","425":"18501caa"}[chunkId] + ".chunk.js";
};